<template>
  <div class="notifications">
    <transition-group name="list" tag="ul">
      <li v-for="(notification, index) in visibleNotifications" :key="notification.id || index" class="list-item" :class="`is-${notification.type}`">
        <div class="notification-message">
          {{ notification.message }}
        </div>
        <span class="material-icons is-clickeable"  @click="removeNotification(notification.id)">
          close
        </span>
      </li>
    </transition-group>
    <transition name="list" mode="out-in">
      <div v-if="pendingNotifications.length" class="notification-pending">
        <span>
          Notificaciones pendientes: {{ pendingNotifications.length }}
        </span>
        <u class="is-clickeable" @click="removeAllNotificationsOneByOne">Cerrar todas</u>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'Notifications',
  computed: {
    ...mapGetters(['notifications', 'visibleNotifications']),

    pendingNotifications () {
      return this.notifications
    }
  },
  methods: {
    ...mapActions(['removeNotification', 'removeAllNotificationsOneByOne'])
  }
}
</script>

<style lang="scss" scoped>
.notifications {
  position: fixed;
  top: 16px;
  right: 16px;
  overflow: visible;
  width: 25vw;
  min-width: 400px;
  padding: 0;
  z-index: 41;
}
.list-item {
  position: relative;
  margin: 5px 0;
  padding: 15px 20px;
  color: #fff;
  border-radius: 5px;
  min-height: 50px;
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;

  .notification-message {
    flex: 1 1 50%;
    font-size: 13px;
    font-weight: 500;
    text-align: center;
  }

}
.list-move,
.list-enter-active,
.list-leave-active {
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}
.list-enter {
  opacity: 0;
  transform: translateX(-20px);
}
.list-leave-to {
  opacity: 0;
  transform: translateX(20px);
}
.list-leave-active {
  position: absolute;
}
.material-icons {
  font-size: 13px;
  position: absolute;
  top: 5px;
  right: 5px;
}
.notification-pending {
  display: flex;
  padding: 10px 16px;
  background-color: #fff;
  border-radius: 5px;
  font-size: 13px;
  font-weight: 500;
  box-shadow: 0 0 4px rgba(0, 123, 255, 1);
  width: 350px;
  margin: 7px 0 0;

  span {
    flex: 1 1 50%;
  }
}
.notification-pending::before {
  content: '🔔';
  margin-right: 4px;
}
.is-clickeable {
  cursor: pointer;
}

@media screen and (max-width: 600px) {
  .notifications {
    width: 100vw;
    min-width: unset;
  }
}
</style>
